import React, { useRef } from "react";
import { Routes } from "../../../types/types";
import Button from "../../ui/Button";
import EntryContent from "../../ui/EntryContent";
import SectionCardDark from "../../ui/SectionCardDark";
import SiteLink from "../../ui/SiteLink";
import "@johanaarstein/dotlottie-player";
import type { DotLottiePlayer } from "@johanaarstein/dotlottie-player";

const Rollups = ({ data }) => {
  const { title, description, cta, list, lottie } = data;
  const animation = useRef<DotLottiePlayer | null>(null);

  return (
    <SectionCardDark>
      <div className="mb-section grid gap-8 lg:grid-cols-2">
        <EntryContent inverted className="max-w-md prose-headings:text-h2">
          <h3>{title}</h3>
        </EntryContent>
        <div className="grid gap-8">
          <EntryContent inverted>
            <p>{description[0].children[0].text}</p>
          </EntryContent>
          <p className="text-background">
            <Button asChild variant={"link-invert"} size={"link"}>
              <SiteLink
                to={Routes.docs}
                external={cta.isExternal}
                iconExternal={cta.isExternal}
              >
                {cta.label}
              </SiteLink>
            </Button>
          </p>
        </div>
      </div>
      <div className="grid gap-6 lg:grid-cols-2">
        <div className="grid gap-6">
          {list._rawItems.map(({ _id, title, description, image }) => (
            <SectionCardDark.CardInner key={_id}>
              <EntryContent
                inverted
                className="prose-headings:mb-2 prose-headings:text-lg"
              >
                <p>
                  <img src={image.asset.url} alt={title} />
                </p>
                <h3>{title}</h3>
                <p>{description[0].children[0].text}</p>
              </EntryContent>
            </SectionCardDark.CardInner>
          ))}
        </div>
        <SectionCardDark.CardInner className="grid gap-12">
          <div>
            <dotlottie-player
              ref={animation}
              autoplay=""
              loop=""
              src="/lottie/cartesi-stack.lottie"
            />
            {/* {lottie.file.asset.url} */}
          </div>
          <EntryContent
            inverted
            className="prose-headings:mb-2 prose-headings:text-lg"
          >
            <h3>{lottie.title}</h3>
            <p>{lottie.description[0].children[0].text}</p>
          </EntryContent>
        </SectionCardDark.CardInner>
      </div>
    </SectionCardDark>
  );
};

export default Rollups;
